goog.require('el8.uiwidget.base');
goog.require('el8.app.setup');
goog.require('el8.appshared.dialog.createPatient');

var el8 = el8 || {};
if (!el8.main) {
  el8.main = {};
}
el8.main.inappreports = {};

el8.main.inappreports.init = function(spec) {
  spec['layout'] = { innerContainerSelector: '#analytics-container', notLegacy: true };

  el8React.renderFindChartHeaderButton('react-chartnav');

  el8.app.setup(spec);
};
